import actions 		from './actions'
import mutations from './mutations'

const state = {
   modal: 0,
   modalVideo: false,
   setorAtivo: 1,
   menu: false,
   infoModal: {
       show: false,
       titulo: null,
       desc: null,
       info: null,
       position: [
         {
            top: null,
            bottom: null,
            left: null,
            right: null
         }
       ]
   },
   infoModalBrasil: {
    show: false,
    titulo: null,
    desc: null,
    info: null,
    position: [
      {
         top: null,
         bottom: null,
         left: null,
         right: null
      }
    ]
}
}


export default {
	namespaced: true,
    state,
	actions,
	mutations
}
